import React, { useState, useRef, useEffect } from "react";
import Zmage from "react-zmage";
import Carousels from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
export default function Portfolio(props) {
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [selectedType, setSelectedType] = useState("all");
  let carouseler = useRef();
  const responsive = {
    lg: {
      breakpoint: { max: 5000, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [])
  
  if (!props.data) return null;

  const itemsPerPage = 5;

  

  const filteredProjects =
    selectedType === "all"
      ? props.data.projects
      : props.data.projects.filter((p) => p.type === selectedType);

  const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);

  // Ensure currentPage is within valid range
  const validCurrentPage = Math.min(currentPage, totalPages) || 1;
  const currentProjects = filteredProjects.slice(
    (validCurrentPage - 1) * itemsPerPage,
    validCurrentPage * itemsPerPage
  );

  // Handle page navigation
  const nextPage = () => {
    setLoading(true);
    if (validCurrentPage < totalPages) setCurrentPage(validCurrentPage + 1);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const prevPage = () => {
    setLoading(true);
    if (validCurrentPage > 1) setCurrentPage(validCurrentPage - 1);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  // Handle filter change
  const handleFilterChange = (type) => {
    setLoading(true);
    setTimeout(() => {
      setSelectedType(type);
      setCurrentPage(1); // Reset to first page when filter changes
      setLoading(false);
    }, 500);
  };

  return (
    <section id="portfolio" className="bg-slate-900 py-6">
      <div className="w-full max-w-7xl mx-auto px-4">
        {/* Filter Buttons */}
        <div className="flex justify-center gap-4 my-6 !mb-12 font-geist">
          {["all", "web", "mobile", "desktop"].map((type) => (
            <button
              key={type}
              onClick={() => handleFilterChange(type)}
              className={`px-4 py-2 text-white rounded ${
                selectedType === type
                  ? "bg-teal-500"
                  : "bg-gray-700 hover:bg-teal-400"
              }`}
            >
              {type.charAt(0).toUpperCase() + type.slice(1)}
            </button>
          ))}
        </div>

        {/* Project List */}
        <div className="grid grid-cols-1 gap-4 px-6">
          {currentProjects.length > 0 ? (
            loading ? (
              <div class="flex items-center justify-center my-12">
                <div class="w-[70px] h-[70px] border-8 border-dashed border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
              </div>
            ) : (
              currentProjects.map((x, i) => (
                <div id={x.id} key={x.id || i} className="sm:mb-12">
                  <div className="group relative grid gap-4 pb-1 transition-all sm:grid-cols-8 sm:gap-10 md:gap-8 lg:hover:!opacity-100 lg:group-hover/list:opacity-50">
                    <div className="absolute -inset-x-4 -inset-y-4 z-0 hidden rounded-md transition lg:block lg:group-hover:bg-slate-800/50 lg:group-hover:shadow-[inset_0_1px_0_0_rgba(148,163,184,0.1)] lg:group-hover:drop-shadow-lg"></div>
                    <div className="z-10 sm:order-2 sm:col-span-5">
                      <h3>
                        <a
                          className="inline-flex items-baseline font-medium leading-tight text-slate-200 hover:text-teal-300 focus-visible:text-teal-300"
                          href={x?.url || undefined}
                          target={x?.url ? "_blank" : undefined}
                          rel={x?.url ? "noreferrer noopener" : undefined}
                          role={!x?.url ? "button" : undefined}
                          tabIndex={!x?.url ? 0 : undefined}
                        >
                          <span className="text-2xl font-geist-bold">
                            {x?.title}
                            {x?.url && (
                              <span className="inline-block ml-1 translate-y-px">
                                🔗
                              </span>
                            )}
                          </span>
                        </a>
                      </h3>
                      <p className="mt-2 text-xl text-white font-geist leading-normal">
                        {x?.category}
                      </p>
                      <ul className="mt-2 flex flex-wrap">
                        {x?.skills?.map((skill, index) => (
                          <li key={index} className="mr-1.5 mt-2">
                            <div className="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xl font-medium font-geist leading-5 text-teal-300">
                              {skill}
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <Carousels
                      ref={carouseler}
                      ssr={true} // means to render carousel on server-side.
                      itemClass="carousel-item-padding-40-px"
                      arrows={true}
                      infinite={true}
                      showDots={true}
                      className="sm:col-span-3"
                      responsive={responsive}
                    >
                      {x &&
                        x.image.map((s, i) => {
                          return (
                            <div>
                              <Zmage
                                alt={x?.title}
                                decoding="async"
                                className="aspect-video object-cover rounded border-2 border-slate-200/10 transition group-hover:border-slate-200/30 sm:order-1 sm:translate-y-1 w-full h-56"
                                loading="lazy"
                                src={"/images/portfolio/" + s}
                              />
                            </div>
                          );
                        })}
                    </Carousels>
                  </div>
                </div>
              ))
            )
          ) : (
            <p className="w-full text-center text-white font-inter text-lg">
              No projects found.
            </p>
          )}
        </div>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="flex justify-center items-center gap-4 mt-8 font-geist">
            <button
              onClick={prevPage}
              disabled={validCurrentPage === 1}
              className="px-4 py-2 bg-gray-700 text-white rounded disabled:opacity-50"
            >
              Previous
            </button>
            <span className="text-white text-lg">
              Page {validCurrentPage} of {totalPages}
            </span>
            <button
              onClick={nextPage}
              disabled={validCurrentPage === totalPages}
              className="px-4 py-2 bg-gray-700 text-white rounded disabled:opacity-50"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
